import gql from 'graphql-tag';

export default gql`
fragment AdminProductCategoryAllDataFragment on AdminProductCategory {
    id
    name
    parent_id
    children {
        id
        name
        parent_id
        children {
            id
            name
            product_count
        }
        url_key
        content
        is_enable
        sort
        date_from
        date_to
        show_in_menu
        keywords
        description
        is_promotion
        is_homepage_prohibited
        product_count
    }
    url_key
    content
    is_enable
    sort
    date_from
    date_to
    show_in_menu
    keywords
    description
    is_promotion
    promotion_place
    is_homepage_prohibited
    product_count
}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/fragments/AdminProductCategoryAllDataFragment.ts